import React, { Component } from "react";
import "./index.scss";
import { connect } from "react-redux";
import { storeChangeObject, storeMenuType } from "@action";
// import { config, srcPath } from "@utils/config";
import vUtil from "@utils/vUtil.min";
import { recordEven } from "@/api/actions";
class VideoMenu extends Component {
  state = {
    showSharePage: false,
    isCanSkip: 0 //是否可以跳过
  };
  // 视频菜单点击
  onMenuClick(type, e) {
    e && e.stopPropagation();
    this.props.dispatch(storeMenuType(type));
  }
  // 暂停或播放
  changeVideoType(type) {
    type ? recordEven("播放") : recordEven("暂停");
    type ? myVideo.play() : myVideo.pause();
  }
  // 更改视频速率
  changeVideoSpeed(num) {
    recordEven(num + "倍速");
    this.props.dispatch(
      storeChangeObject({
        videoSpeed: num
      })
    );
    myVideo.playbackRate = num;
  }
  // 跳过
  onVideoSkip() {
    const { videoData } = this.props;
    if (
      this.state.isCanSkip ||
      this.props.showChoices ||
      !"choices" in videoData ||
      (videoData.condition == 1 &&
        myVideo.currentTime >= myVideo.duration - 2) ||
      (videoData.condition == 2 &&
        myVideo.currentTime >= videoData.conditionTime - 2 &&
        myVideo.currentTime < videoData.conditionTime)
    ) {
      return;
    }
    this.state.isCanSkip = setTimeout(() => {
      this.state.isCanSkip = 0;
    }, 4000);
    recordEven("跳过");
    // 跳转到下个当前节点、跳转到结束的节点、到转到结束
    if (
      videoData.condition == 1 ||
      (videoData.nextPath == "end" && videoData.condition != 2)
    ) {
      myVideo.currentTime = myVideo.duration - 1;
    } else if (videoData.conditionTime > myVideo.currentTime) {
      myVideo.currentTime = videoData.conditionTime - 1;
    } else {
      myVideo.currentTime = myVideo.duration - 1;
    }
  }
  // 是否展示分享页
  isShowShare(type) {
    if (!type) {
      audioBtn.play();
      recordEven("关闭保存页");
    } else {
      recordEven("展示保存页");
    }
    this.setState({
      showSharePage: type
    });
    !type ? myVideo.play() : myVideo.pause();
  }
  render() {
    const { props, state } = this;
    return (
      <div style={{ opacity: props.isShowMenu ? 1 : 0 }}>
        {/* 分享页面 */}
        {state.showSharePage && (
          <div
            className="toast_bg"
            style={{ zIndex: "100" }}
            onClick={e => e.stopPropagation()}
          >
            <img
              src={
                vUtil.UA.pc
                  ? require("@img/share_pc.png")
                  : require("@img/share.png")
              }
              className={`share_top_img ${
                props.videoFullScreen
                  ? props.isHuawei
                    ? "add_ttop"
                    : "add_top"
                  : ""
              }`}
            ></img>
            <div
              className="toast_go"
              onClick={this.isShowShare.bind(this, false)}
            >
              继续
            </div>
          </div>
        )}

        <div
          className={`menu_box dis_f fle_t ali_ct animated ${
            props.showMenu ? "fadeInRight" : "fadeOutRight"
          }`}
          onClick={e => this.onMenuClick.bind(this)(true, e)}
        >
          {/* 跳过该视频 */}
          <img
            onClick={this.onVideoSkip.bind(this)}
            src={require("@img/btn-skip.png")}
          ></img>
          {/* 调节速度 */}
          {props.videoSpeed == 1 ? (
            <img
              src={require("@img/btn-speed-1.png")}
              onClick={this.changeVideoSpeed.bind(this, 2)}
            ></img>
          ) : (
            <img
              src={require("@img/btn-speed-2.png")}
              onClick={this.changeVideoSpeed.bind(this, 1)}
            ></img>
          )}

          {/* 保存到本地 */}
          <img
            onClick={this.isShowShare.bind(this, true)}
            src={require("@img/btn-collect.png")}
          ></img>
          {/* 暂停 */}
          {props.videoPlay ? (
            <img
              onClick={this.changeVideoType.bind(this, false)}
              src={require("@img/btn-pause.png")}
            ></img>
          ) : (
            <img
              onClick={this.changeVideoType.bind(this, true)}
              src={require("@img/btn-play.png")}
            ></img>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(VideoMenu);
